/**
 * La voix d'une vignette, à droite du nom : les barres de `<VoiceBars>`, qui ondulent tant que son participant parle
 * (`useSpeaking`). Un composant à part : la tuile, elle, reste sans crochet, et seule cette pièce se redessine quand
 * il se met à parler ou se tait. Sans source de la parole (une story, un écran qui n'en veut pas), rien.
 */
import React from "react"

import { VoiceBars } from "../../atoms/VoiceBars"
import { useSpeaking } from "../../hooks/useSpeaking"

export function TileVoice({ participantId, size }: { participantId: string; size?: number }) {
    const speaking = useSpeaking(participantId)
    if (speaking == null) return null
    return <VoiceBars speaking={speaking} size={size} />
}
